.tooltip {
    padding: var(--spacer-4) var(--spacer-8);
    background: var(--color-primary);
    border-radius: var(--border-radius-sm);
    color: var(--color-contrast);
    font: var(--font-nav-14);
    white-space: nowrap;

    &[data-placement="bottom"] {
        margin-top: var(--spacer-4);
    }
}
